"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

interface ProgressProps {
  value?: number;   // 0–100
  className?: string;
}

/**
 * Simple accessible progress bar.
 * Accepts a `value` prop from 0 to 100.
 */
function Progress({ value = 0, className, ...props }: ProgressProps & React.HTMLAttributes<HTMLDivElement>) {
  const clamped = Math.min(100, Math.max(0, value));
  return (
    <div
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn("relative h-2 w-full rounded-full", className)}
      style={{ backgroundColor: 'rgb(217, 206, 188)' }}
      {...props}
    >
      <div
        className="h-full rounded-full bg-primary transition-all duration-500"
        style={{ width: `${clamped}%` }}
      />
    </div>
  )
}

export { Progress }
